export enum ButtonTier {
    FIRST = "FIRST",
    SECOND = "SECOND"
}

export enum ButtonProminence {
    HIGH = "HIGH",
    LOW = "LOW",
}

export enum ButtonConnotation {
    AFFIRMATIVE = "AFFIRMATIVE",
    DISSUASIVE = "DISSUASIVE",
    NEGATIVE = "NEGATIVE"
}

export enum ButtonLayout {
    HORIZONTAL,
    VERTICAL
}
